import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function CategoryGrid() {
  return (
    <section className="w-full py-16 md:py-24 bg-background-50">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-start gap-4 md:gap-12 mb-12">
          <div className="md:w-[380px] flex-shrink-0">
            <h2
              className="text-4xl md:text-5xl font-heading font-bold text-foreground-950 leading-tight"
              style={{ fontFamily: 'var(--font-heading)' }}
            >
              吃瓜频道
              <br />
              分类导航
            </h2>
          </div>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-md pt-2">
            按分类浏览您感兴趣的爆料内容，涵盖网红黑料、明星塌房、综艺翻车、
            社会大瓜等热门频道，总有一个瓜适合你。
          </p>
        </div>

        {/* Category Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
          {categories.slice(0, 6).map((cat, index) => {
            const isLarge = index === 0;
            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`group block rounded-xl overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer ${
                  isLarge
                    ? 'md:row-span-2 bg-background-100'
                    : 'bg-background-100'
                }`}
              >
                {isLarge ? (
                  <div className="flex flex-col h-full">
                    <div className="aspect-[16/9] overflow-hidden">
                      <img
                        src="https://readdy.ai/api/search-image?query=Dark%20moody%20social%20media%20influencer%20scene%20with%20phone%20screen%20glowing%20in%20darkness%2C%20dramatic%20red%20accents%2C%20scandal%20and%20expose%20theme%2C%20cinematic%20photography%2C%20warm%20dark%20tones%2C%20mysterious%20atmosphere%2C%20no%20text%2C%20clean%20composition&width=800&height=450&seq=cat-wanghong-heiliao&orientation=landscape"
                        alt={cat.name}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                      />
                    </div>
                    <div className="p-5 flex flex-col flex-1 justify-end">
                      <h3 className="text-foreground-950 font-heading font-bold text-xl mb-2" style={{ fontFamily: 'var(--font-heading)' }}>
                        {cat.name}
                      </h3>
                      <p className="text-foreground-600 text-sm leading-relaxed">{cat.description}</p>
                    </div>
                  </div>
                ) : (
                  <div className="flex flex-col h-full">
                    <h3 className="text-foreground-950 font-heading font-bold text-lg text-center pt-5 px-5 mb-3" style={{ fontFamily: 'var(--font-heading)' }}>
                      {cat.name}
                    </h3>
                    <div className="aspect-[16/10] overflow-hidden">
                      <img
                        src={`https://readdy.ai/api/search-image?width=600&height=380&seq=cat-${cat.slug}&orientation=landscape&query=Modern%20minimalist%20entertainment%20news%20concept%20with%20warm%20dark%20and%20coral%20toned%20abstract%20background%2C%20dramatic%20lighting%2C%20magazine%20editorial%20style%2C%20soft%20shadows%2C%20no%20text%2C%20clean%20composition`}
                        alt={cat.name}
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                      />
                    </div>
                    <p className="text-foreground-500 text-xs text-center px-4 py-4 leading-relaxed">{cat.description}</p>
                  </div>
                )}
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}